import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NewsletterSub from '../classes/newsletter.ts';
import { getDeviceData } from '../security/device-detector';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainerWrapper } from '../common/ToastContainerWrapper';
import { VERSION } from '../servicios_al_cliente/updates';

function Footer(props) {
  const [Email, setEmail] = useState(null);

  const newsletter = async (e) => {
    e.preventDefault();
    let _newsletter = new NewsletterSub();
    let devData = getDeviceData();
    let email = e.target.EMAIL.value;
    if (email) {
      let _res = await _newsletter.subToNewsletter(devData, 1, email);
      if (_res && _res.statusCode === 200) {
        toast.success('Te suscribiste al Newsletter!');
        // props.getCheckoutData();
      } else if (_res) {
        toast.warn(_res.statusMsg);
      }
    } else {
      toast.warn('Tenés que ingresar un email');
    }
  };

  return (
    <footer className="site-footer" style={{ backgroundImage: 'url(img/footer-bg.png)' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-3">
            {/* Categories*/}
            <section className="widget widget-links widget-light-skin">
              <h3 className="widget-title">Catálogo</h3>
              <div className="row">
                <div className="col-md-12">
                  <ul>
                    <li>
                      <Link to="/productLane/00000002" className="mt-1">
                        Papelería
                      </Link>
                    </li>
                    <li>
                      <Link to="/productLane/00000001" className="mt-1">
                        Escritura
                      </Link>
                    </li>
                    <li>
                      <Link to="/productLane/00000003" className="mt-1">
                        Computación
                      </Link>
                    </li>
                    <li>
                      <Link to="/productLane/00000005" className="mt-1">
                        Básicos Oficina
                      </Link>
                    </li>
                    <li>
                      <Link to="/productLane/00000006" className="mt-1">
                        Achivo y Carpetas
                      </Link>
                    </li>
                    <li>
                      <Link to="/productLane/00000009" className="mt-1">
                        Presentación
                      </Link>
                    </li>
                    <li>
                      <Link to="/productLane/00000008" className="mt-1">
                        Electrónicos
                      </Link>
                    </li>
                    <li>
                      <Link to="/productLane/00000007" className="mt-1">
                        Cafetería
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
          <div className="col-lg-3">
            {/* Categories*/}
            <section className="widget widget-links widget-light-skin">
              <h3 className="widget-title">Marcas Top</h3>
              <div className="row">
                <div className="col-md-12">
                  <ul>
                    <li>
                      <Link to="/productBrand/AUTOR" className="mt-1">
                        Autor
                      </Link>
                    </li>
                    <li>
                      <Link to="/productBrand/HP" className="mt-1">
                        HP
                      </Link>
                    </li>
                    <li>
                      <Link to="/productBrand/EDDING" className="mt-1">
                        Edding
                      </Link>
                    </li>
                    <li>
                      <Link to="/productBrand/Staedtler" className="mt-1">
                        Staedtler Oficina
                      </Link>
                    </li>
                    <li>
                      <Link to="/productBrand/Legamaster" className="mt-1">
                        Legamaster y Carpetas
                      </Link>
                    </li>
                    <li>
                      <Link to="/productBrand/Verbatim" className="mt-1">
                        Verbatim
                      </Link>
                    </li>
                    <li>
                      <Link to="/productBrand/Clingsor" className="mt-1">
                        Clingsor
                      </Link>
                    </li>
                    <li>
                      <Link to="/productBrand/Medoro" className="mt-1">
                        Medoro
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>

          <div className="col-lg-3 col-md-6">
            {/* About Us*/}
            <section className="widget widget-links widget-light-skin">
              <h3 className="widget-title">Políticas de la Compañía</h3>
              <ul>
                <li>
                  <Link to="/Contacto" className="mt-1">
                    Contacto
                  </Link>
                </li>
                <li>
                  <Link to="/QuienesSomos" className="mt-1">
                    Quienes Somos
                  </Link>
                </li>
                <li>
                  <Link to="/Envios" className="mt-1">
                    Envíos
                  </Link>
                </li>
                <li>
                  <Link to="/userInfo/orders" className="mt-1">
                    Seguimiento de pedido
                  </Link>
                </li>
                <li>
                  <Link to="/FormasDePago" className="mt-1">
                    Formas de pago
                  </Link>
                </li>
                <li>
                  <Link to="/PoliticasCia" className="mt-1">
                    Políticas de la Compañía
                  </Link>
                </li>
                <li>
                  <Link to="/Faqs" className="mt-1">
                    Preguntas frecuentes
                  </Link>
                </li>
                <li>
                  <Link to="/TyC" className="mt-1">
                    Términos y Condiciones
                  </Link>
                </li>
                <li>
                  <Link to="/PoliticasPrivacidad" className="mt-1">
                    Políticas de Privacidad
                  </Link>
                </li>
              </ul>
            </section>
          </div>
          <div className="col-lg-3 col-md-6">
            {/* Account / Shipping Info*/}
            <section className="widget widget-links widget-light-skin">
              <h3 className="widget-title">PlanetPlus</h3>
              <ul>
                <li>
                  <Link to="/productLane/PlanetPlus" className="mt-1">
                    Catalogo PlanetPlus
                  </Link>
                </li>
                <li>
                  <Link to="/userInfo/planet_plus" className="mt-1">
                    Mis Puntos PlanetPlus
                  </Link>
                </li>
                <li>
                  <Link to="/userInfo/planet_plus" className="mt-1">
                    Asociarse a PlanetPlus
                  </Link>
                </li>
                <li>
                  <Link to="/ProgramaPlanetPlus" className="mt-1">
                    Bases y condiciones
                  </Link>
                </li>
              </ul>
            </section>
          </div>
        </div>
        <hr className="hr-light mt-2 margin-bottom-2x hidden-md-down" />
        <div className="row">
          <div className="col-lg-3 col-md-6">
            {/* Contact Info*/}
            <section className="widget widget-light-skin">
              <h3 className="widget-title">Contactáte con nosotros</h3>
              <p className="text-white">Teléfono: +54 (11) 3220-6620</p>
              <ul className="list-unstyled text-sm text-white">
                <li>
                  <span className="opacity-50">Lunes-Viernes:&nbsp;</span>08:30hs a 18:00hs
                </li>
              </ul>
              <p>
                <a className="navi-link-light" href="mailto:comercial@planetoffice.com.ar">
                  Envianos un email
                </a>
              </p>
              <a
                target={'_blank'}
                href="https://www.facebook.com/planetoffice2.0/"
                className="social-button shape-circle sb-facebook sb-light-skin"
                rel="noreferrer"
              >
                <i className="socicon-facebook" />
              </a>
              <a
                target={'_blank'}
                href="https://www.instagram.com/planetofficearg/"
                className="social-button shape-circle sb-instagram sb-light-skin"
                rel="noreferrer"
              >
                <i className="socicon-instagram" />
              </a>
              <a
                target={'_blank'}
                href="https://wa.link/gfgltr"
                className="social-button shape-circle sb-whatsapp sb-light-skin"
                rel="noreferrer"
              >
                <i className="socicon-whatsapp" />
              </a>
              <a
                target={'_blank'}
                href="https://www.linkedin.com/company/tecdata-arg/"
                className="social-button shape-circle sb-linkedin sb-light-skin"
                rel="noreferrer"
              >
                <i className="socicon-linkedin" />
              </a>
            </section>
          </div>

          <div className="col-lg-9">
            {/* Subscription*/}
            <section className="widget widget-light-skin">
              <h3 className="widget-title">Mantenete informado</h3>
              <form
                className="row"
                action="//rokaux.us12.list-manage.com/subscribe/post?u=c7103e2c981361a6639545bd5&amp;id=1194bb7544"
                method="post"
                target="_blank"
                noValidate
                onSubmit={(e) => {
                  newsletter(e);
                }}
              >
                <div className="col-sm-9">
                  <div className="input-group input-light">
                    <input
                      className="form-control"
                      type="email"
                      name="EMAIL"
                      placeholder="Tu e-mail"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <span className="input-group-addon">
                      <i className="icon-mail" />
                    </span>
                  </div>
                  {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups*/}
                  <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                    <input type="text" name="b_c7103e2c981361a6639545bd5_1194bb7544" tabIndex={-1} />
                  </div>
                  <p className="form-text text-sm text-white opacity-50 pt-2">
                    Suscribite a nuestro Newsletter para recibir descuentos, las últimas novedades, ofertas e
                    información de promociones.
                  </p>
                </div>
                <div className="col-sm-3">
                  <button
                    className="btn btn-primary btn-block mt-0"
                    type="submit"
                    disabled={Email ? false : true}
                  >
                    Suscribite
                  </button>
                </div>
              </form>
              <div className="pt-3 tw-flex">
                <img alt="tarjeta visa" title='ofertas visa' src="img/tarjetas/Visa.gif" className="card-img min-width-40 min-heigth-32"></img>
                <img alt="tarjeta mastercard" title='ofertas tarjeta mastercard' src="img/tarjetas/Mastercard.gif" className="card-img min-width-40 min-heigth-32"></img>
                <img
                  alt="tarjeta american express"
                  src="img/tarjetas/AmericanExpress.gif"
                  className="card-img min-width-40 min-heigth-32"
                  title='ofertas american express'
                ></img>
                <img alt="tarjeta cabal" title='ofertas cabal' src="img/tarjetas/Cabal.gif" className="card-img min-width-40 min-heigth-32"></img>
                <img alt="tarjeta diners" title='ofertas diners' src="img/tarjetas/Diners.gif" className="card-img min-width-40 min-heigth-32"></img>
                <img alt="tarjeta visa debito" title='ofertas visa' src="img/tarjetas/VisaDebito.gif" className="card-img min-width-40 min-heigth-32"></img>
                <img alt="tarjeta maestro" title='ofertas tarjeta maestro' src="img/tarjetas/Maestro.gif" className="card-img min-width-40 min-heigth-32"></img>
              </div>
            </section>
          </div>
        </div>
        {/* Copyright*/}
        <p className="footer-copyright">
          Copyright {new Date().getFullYear()} Tecdata | Todos los derechos reservados | PlanetOffice.com.ar |{' '}
          <Link to="/UPDATES">
            <span>v. {VERSION}</span>{' '}
          </Link>
        </p>{' '}
        <p className="footer-copyright">
          {' '}
          Normas de confidencialidad y privacidad Las imagenes son de caracter ilustrativo y son solo a modo
          de referencia.
        </p>
        <p className="footer-copyright">
          PlanetOffice es una marca propiedad de Osso Gustavo J. y Cazamajou Ruben E. S.H (cuit 30-69504518-9)
          &nbsp;
        </p>
      </div>
      <ToastContainerWrapper />
    </footer>
  );
}

export default Footer;
